'use client'

import Icon, { type IAvailableIcons } from '@/components/v2/ui/icon'
import { useTexts } from '@/contexts/LanguageContext'
import { useTrustCenterConfig } from '@/contexts/TrustCenterContext'
import S from '@/settings'

const DEFAULT_CONTACT_EMAIL = S.EMAIL_ADDRESSES.TRUST_CENTER

function ContactCard({
  icon,
  title,
  body,
  email,
}: {
  icon: IAvailableIcons
  title: string
  body: string
  email: string
}) {
  return (
    <div className="flex flex-col gap-1.5 rounded border border-trust-center-border p-4">
      <Icon icon={icon} className="size-4 text-trust-center-accent" />
      <span className="text-sm font-semibold">{title}</span>
      <span className="text-sm text-pretty text-trust-center-muted">{body}</span>
      <a
        href={`mailto:${email}`}
        className="mt-1 self-start text-sm font-medium text-trust-center-accent hover:text-trust-center"
      >
        {email}
      </a>
    </div>
  )
}

export default function ContactsOverview() {
  const { CONTACTS } = useTexts().PUBLIC_TRUST_CENTER.OVERVIEW
  const { vulnerabilityEmail, questionnairesEmail } = useTrustCenterConfig()
  return (
    <section className="grid gap-4 py-8 md:grid-cols-2">
      <ContactCard
        icon="shield-alert"
        title={CONTACTS.VULNERABILITY.TITLE}
        body={CONTACTS.VULNERABILITY.BODY}
        email={vulnerabilityEmail ?? DEFAULT_CONTACT_EMAIL}
      />
      <ContactCard
        icon="mail"
        title={CONTACTS.QUESTIONNAIRES.TITLE}
        body={CONTACTS.QUESTIONNAIRES.BODY}
        email={questionnairesEmail ?? DEFAULT_CONTACT_EMAIL}
      />
    </section>
  )
}
